// Local translations
export const T = {
  en_GB: {
    process: "Process",
    unreadMessages: (n: number) => `${n} unread ${n === 1 ? "message" : "messages"}`,
  },
  nb_NO: {
    process: "Prosess",
    unreadMessages: (n: number) => `${n} ${n === 1 ? "ulest melding" : "uleste meldinger"}`,
  },
} as const;
